'use client';

import React, { FC, useMemo } from 'react';
import { twMerge } from 'tailwind-merge';

interface EmblaPaginationDotsProps {
  totalSlides: number;
  selectedIndex: number;
}

const styles = {
  wrap: 'absolute w-full bottom-3 flex justify-center items-center',
  dot: 'w-1.5 h-1.5 shrink-0 rounded-full mx-1 transition-colors bg-fill-dot',
  activeDot: 'w-2 h-2 bg-fill-rose',
};

export const EmblaPaginationDots: FC<EmblaPaginationDotsProps> = ({
  totalSlides,
  selectedIndex,
}) => {
  const maxDots = 7;
  const dotsToShow = totalSlides < maxDots ? totalSlides : maxDots;

  const startIndex =
    totalSlides >= maxDots
      ? selectedIndex < 3
        ? 0
        : selectedIndex > totalSlides - 4
          ? totalSlides - maxDots
          : selectedIndex - 3
      : 0;

  const windowDots = useMemo(
    () => Array.from({ length: dotsToShow }, (_, i) => startIndex + i),
    [startIndex, dotsToShow],
  );

  return (
    <div className={styles.wrap}>
      {windowDots.map((dotValue, index) => {
        const isActive = dotValue === selectedIndex;
        const dotClasses = twMerge(styles.dot, isActive && styles.activeDot);
        return <span key={index} className={dotClasses} />;
      })}
    </div>
  );
};
